<template>
    <div>

        <b-card-body>
            <b-row>
                <draggable :list="imagenes" @update="moverImagen" :options="{handle:'.handle'}">
                <b-col v-for="(element,index) in imagenes" :key="index" md="12" class="text-center">

                        <!-- Editar y eliminar -->
                            <b-button-group v-if="puedeModificarImagen && !subiendoImg" size="sm" class="pull-right">
                                <b-button 
                                    size="sm" 
                                    :variant="element.visible ? 'outline-success' : 'outline-secondary'"
                                    @click="cambiaVisible(element._id)">
                                    <i :class="element.visible ? 'fa fa-lg fa-globe': 'fa fa-lg fa-globe'"></i>
                                </b-button>
                                <b-button class="handle"
                                    variant="outline-secondary"
                                    v-b-tooltip.hover title="Mover de posición">
                                    <i class="fa fa-arrows-alt fa-lg"></i>
                                </b-button>
                                <b-button 
                                    variant="outline-secondary"
                                    @click="eliminaImagen(element._id,index)"
                                    v-b-tooltip.hover title="Eliminar imagen">
                                    <i class="fa fa-trash fa-lg"></i>
                                </b-button>
                            </b-button-group>
                        <b-img :src="httpURL+'/'+element.path" fluid alt="Responsive image" />

                </b-col>
                </draggable>
            </b-row>

            <div v-if="puedeAgregarImagen && !subiendoImg" class="text-right">
                <br>
                <b-button 
                    size="sm"
                    variant="primary"
                    @click="$refs.nuevaImg.click()">
                    Agregar imagen
                </b-button>


                <input 
                    type="file" 
                    @change="agregarImagen" 
                    style="display: none;"
                    ref="nuevaImg" />
            </div>
            <div>
                <b-progress 
                    v-if="subiendoImg"
                    class="progreso-img" 
                    variant="primary" 
                    :value="progreso" 
                    :max="100" 
                    show-progress animated>
                </b-progress>
            </div>
            <br>
        </b-card-body>

    </div>
</template>

<script>
import swal from 'sweetalert'
import axios from 'axios'
import { mapGetters } from "vuex";

import draggable from 'vuedraggable'

export default {
  name: 'ItemImagenes',
  props: ["imagenes","tipoItem"],
  components:{
    draggable
  },
  computed: {
    ...mapGetters([
      "httpURL",
      "sessionToken",
      "permisos",
      "role"
    ]),
    puedeAgregarImagen(){
      if( this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 140) >= 0 )
        return true;
      else
        return false;
    },
    puedeModificarImagen(){
      if( this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 141) >= 0 )
        return true;
      else
        return false;
    },
    puedeEliminarImagen(){
      if( this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 142) >= 0 )
        return true;
      else
        return false;
    },
    editor() {
        return this.$refs.myTextEditor.quill
      },
  },
  watch: {
      '$route'(to, from) {
        this.id = to.params.id;
      }
  },
  data: function () {
    return {
        titulo: this.$route.name,
        id: this.$route.params.id,
        subiendoImg: false,
        progreso: 50
    }
  },
  methods: {
    agregarImagen(){
        const file = event.target.files[0];
        const allowedTypes = ['image/jpg','image/jpeg','image/png','image/gif'];
        if( allowedTypes.includes(file.type)){
            //console.log('Se sube la imagen');
            const formData = new FormData();
            formData.append('image',file);
            this.subiendoImg = true;
            axios.post(this.httpURL+'/transparencia/normatividad/'+this.tipoItem+'/'+this.id+'/imagenes',
                formData,
                {headers: {token:this.sessionToken},
                onUploadProgress: e => this.progreso = Math.round(e.loaded * 100 / e.total)
                })
            .then(res => {
                this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000,
                            text: res.data.mensaje });
                setTimeout(()=>{ 
                    this.$emit('nuevaImagen',res.data.imagen);
                    this.subiendoImg = false;
                }, 200);
            })
            .catch(error => {
                if(error.response){
                    //console.log(error.response);
                    this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                        text: error.response.data.mensaje });
                }else if( error.request){
                    this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                        text: 'No se pudo establecer una conexión al servidor.' });
                }
                this.subiendoImg = false;
            });
        }else
            this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                      text: 'Debe seleccionar una imagen.' });
    },
    eliminaImagen(idImg,index){
        swal({
                icon: 'info',
                title: 'Área protegida',
                text: 'Esta acción requiere de tu contraseña:',
                content: {
                element: "input",
                attributes: {
                placeholder: "Ingrese...",
                type: "password",
            }
            },
                closeOnClickOutside: true,
                button: {
                text: "Confirmar",
                closeModal: false,
            },
        })
        .then(password => {
            if (!password){
                swal.close();
            }else{
                this.enviando = true;
                //console.log('Se elimina '+idImg);
                axios.delete(this.httpURL+'/transparencia/normatividad/'+this.tipoItem+'/'+this.id+'/imagenes/'+idImg,
                        {data:{password},headers: {token:this.sessionToken}})
                    .then(res => {
                        swal.close();
                        this.$emit('eliminaImagen',index);
                        this.enviando = false;
                        this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000,
                            text: res.data.mensaje });
                    })
                    .catch(error => {
                        swal.close();
                        if(error.response){
                            //console.log(error.response);
                            this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                                text: error.response.data.mensaje });
                        }else if( error.request){
                            this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                                text: 'No se pudo establecer una conexión al servidor.' });
                        }
                        this.enviando = false;
                    });
            }
        });
    },
    moverImagen(){
      let imgIds = [];
      this.imagenes.forEach(element => {
        imgIds.push(element._id);
      });

      imgIds = imgIds.toString();

      this.enviando = true;
      axios.put(this.httpURL+'/transparencia/normatividad/'+this.tipoItem+'/'+this.id+'/moverImg',
              {imagenes:imgIds},
              {headers: {token:this.sessionToken}})
          .then(res => {
              //this.docs.splice(index,1);
              //this.enviando = false;
              this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000,
                  text: 'Cambios guardados correctamente' });
          })
          .catch(error => {
              //console.log(error.response);
              //this.enviando = false;
            if(error.response){
                this.error = error.response.data.mensaje;
                //console.log(error.response);
                this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                    text: error.response.data.mensaje });
            }else if( error.request){
                this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                    text: 'No se pudo establecer una conexión al servidor.' });
            }
          });
    },
    cambiaVisible(img){
      this.enviando = true;
      axios.put(this.httpURL+'/transparencia/normatividad/'+this.tipoItem+'/'+this.id+'/imagenes/'+img+'/visible',
              {},
              {headers: {token:this.sessionToken}})
          .then(res => {
              //this.docs.splice(index,1);
              //this.enviando = false;
              if( res.data.ok ){
                  this.$emit('imagenVisible',{img,visible: res.data.visible});
                  this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000,
                      text: 'Cambios guardados correctamente' });
              }
          })
          .catch(error => {
             // console.log(error.response);
              //this.enviando = false;
            if(error.response){
                this.error = error.response.data.mensaje;
                //console.log(error.response);
                this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                    text: error.response.data.mensaje });
            }else if( error.request){
                this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                    text: 'No se pudo establecer una conexión al servidor.' });
            }
          });

    },
    regresar(){
        this.$router.go(-1);
    }
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }

div.show-image {
    position: relative;
    float:left;
    margin:5px;
}

.edit {
	padding-top: 0px;	
	padding-right: 0px;
	position: absolute;
	right: 5px;
	top: 5px;
	display: none;
}

div.show-image .progreso-img{
	padding-top: 0px;	
	padding-right: 0px;
	position: absolute;
    width: 100%;
	top: 50%;
	display: block;
}
</style>
